import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';
import { BiCheck, BiX } from 'react-icons/bi';

const MailServerIncluded = () => {
  const { t } = useTranslations();
  const included = [1, 2, 3, 4, 5].map((n) => t(`managedServices_mailServer_included${n}`));
  const excluded = [1, 2, 3].map((n) => t(`managedServices_mailServer_excluded${n}`));

  return (
    <section className="ms-section ms-section--alt">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_mailServer_scope_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_mailServer_scope_title')}</h2>
        </div>
        <div className="row">
          <div className="col-lg-7 mb-4 mb-lg-0">
            <div className="ms-scope-card ms-scope-card--included">
              <h3>{t('managedServices_mailServer_included_title')}</h3>
              <ul className="ms-scope-card__list">
                {included.map((line, i) => (
                  <li key={i}>
                    <BiCheck className="ms-scope-card__icon ms-scope-card__icon--yes" aria-hidden />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="ms-scope-card ms-scope-card--excluded">
              <h3>{t('managedServices_mailServer_excluded_title')}</h3>
              <ul className="ms-scope-card__list">
                {excluded.map((line, i) => (
                  <li key={i}>
                    <BiX className="ms-scope-card__icon ms-scope-card__icon--no" aria-hidden />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MailServerIncluded;
